import React from "react";

// =====================================================================
//  SparkIcon — 4-point sparkle mark for the "AI READY · MIDAS" surfaces (DR-2)
//  Path data from Paper artboard v2-1 (blue AI-READY ribbon). Mirrors the
//  OemStar shared pattern; `fill` is caller-supplied (default = the AI-blue
//  ribbon spark #3498DB).
// =====================================================================

interface SparkIconProps {
  size?: number;
  fill?: string;
}

const SparkIcon: React.FC<SparkIconProps> = ({ size = 12, fill = "#3498DB" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ flexShrink: 0 }}
  >
    <path d="M12 2l2.4 7.6L22 12l-7.6 2.4L12 22l-2.4-7.6L2 12l7.6-2.4z" fill={fill} />
  </svg>
);

export default SparkIcon;
